import React, { memo } from 'react';
import { default as DefaultIcon } from './Icon';
import IconGradient from './IconGradient';
const Icon = /*#__PURE__*/memo(_ref => {
  let {
    hasGradient,
    ...props
  } = _ref;
  return hasGradient ? /*#__PURE__*/React.createElement(IconGradient, props) : /*#__PURE__*/React.createElement(DefaultIcon, props);
});
Icon.displayName = 'Icon';
export default Icon;